import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import utils from '@/mixins/utils.js'
import store from '@/store/store'
import { api, apiPublic } from '@/plugins/axios.js'
import { vue } from '@/main.js'

// Retorna os cadastros por microárea
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da equipe
 * @param {int} micro_area - microárea do profissional
 */
export async function getCadastrosPorMicroArea(cod_ibge, nu_ine, micro_area) {
  try {
    const { data } = await api.get(
      `/app/condicoes-saude/${cod_ibge}/equipe/${nu_ine}/microarea/${micro_area}`
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

// Retorna os cadastros por equipe
/**
 * @param {int} cod_ibge - IBGE do município
 * @param {int} nu_ine - INE da Equipe
 */
export async function getCadastrosPorEquipe(cod_ibge, nu_ine) {
  try {
    const { data } = await api.get(
      '/app/condicoes-saude/' + cod_ibge + '/equipe/' + nu_ine
    )
    return data
  } catch (err) {
    console.log(err)
  }
}

export function generatePdf(cadastros, selectEquipe, microArea) {
  let title_pdf = 'Condições Saúde'
  let titlePdfSave = utils.methods.titlePdf(
    'Condições Saúde',
    selectEquipe.no_equipe
  )
  let description_pdf = 'Situação e condições de saúde por cidadão'
  let headers_pdf = [
    'NOME',
    'NASCIMENTO',
    'MÃE',
    'MA',
    'CONDIÇÕES DE SAÚDE',
    'MÉDICO(A)',
    'ENFERMEIRO(A)',
    'ODONTÓLOGO(A)',
    'VISITA',
    'CADASTRADO POR',
  ]
  var data_pdf = []
  for (let i = 0; i < cadastros.length; i++) {
    var obj = {}
    obj.no_cidadao = cadastros[i].no_cidadao
    obj.dt_nascimento = utils.methods.formatDate(cadastros[i].dt_nascimento)
    obj.no_mae = cadastros[i].no_mae
    obj.micro_area = cadastros[i].micro_area
    /*  obj.comorbidades = cadastros[i].comorbidades
      .map((comorbidade) => comorbidade.label)
      .join(', ') */
    obj.comorbidades = filtrarComorbidades(cadastros[i].comorbidades)
      .map((c) => c.label)
      .join(', ')
    obj.medico = utils.methods.formatDate(cadastros[i].dt_ult_fai_med)
    obj.enfermeiro = utils.methods.formatDate(cadastros[i].dt_ult_fai_enf)
    obj.odontologo = utils.methods.formatDate(cadastros[i].dt_ult_fao)
    obj.visita = utils.methods.formatDate(cadastros[i].dt_ult_fvdt)
    obj.cadastrado_por = cadastros[i].no_profissional
    data_pdf.push(obj)
  }
  let doc = new jsPDF({
    orientation: 'l',
  })
  // cria a tabela
  let table = utils.methods.createTablePdf(data_pdf)

  utils.methods
    .fileToBase64(store.state.infoMunicipio.brasao)
    .then((base64data) => {
      // Header
      let verticalPosition = utils.methods.headerPdf(
        doc,
        base64data,
        title_pdf,
        description_pdf,
        287
      )

      verticalPosition = utils.methods.bodyPdf(
        doc,
        [
          {
            label: 'Equipe',
            value: selectEquipe.no_equipe,
          },
          {
            label: 'CNES',
            value: selectEquipe.nu_cnes,
          },
          {
            label: 'INE',
            value: selectEquipe.ine_esf_eap,
          },
          {
            label: 'Microárea',
            value: microArea,
          },
        ],
        verticalPosition
      )

      doc.autoTable({
        head: [headers_pdf],
        body: table,
        headStyles: {
          fillColor: '#ccc',
          fontSize: 6,
          textColor: '#000',
          halign: 'center',
          cellWidth: 'wrap',
        },
        bodyStyles: {
          halign: 'center',
          fontSize: 6,
        },
        theme: 'striped',
        startY: verticalPosition,
        showHead: 'firstPage',
        willDrawCell: function (data) {
          if (data.row.section === 'head') {
            doc.setTextColor(0, 0, 0)
          }
        },
      })

      utils.methods.footerPdfCentralizado(doc, doc.autoTable.previous.finalY)

      doc.save(titlePdfSave + '.pdf')

      vue.$toast.success('PDF GERADO COM SUCESSO!', 'Sucesso:', {
        position: 'topRight',
      })
    })
    .catch((error) => {
      console.error(error)
      vue.$toast.error('ERRO AO GERAR PDF!', 'Erro:', {
        position: 'topRight',
      })
    })
}

export const doencas = [
  { label: 'Todas', value: 'todas' },
  { label: 'Acamado', value: 'acamado' },
  { label: 'Câncer', value: 'cancer' },
  { label: 'Deficiência', value: 'def' },
  { label: 'AVC', value: 'st_avc' },
  { label: 'Doenças cardíacas', value: 'doencaCardiaca' },
  { label: 'Doenças nos rins', value: 'doencaRins' },
  { label: 'Doenças respiratórias', value: 'doencaRespiratoria' },
  { label: 'Domiciliado', value: 'domiciliado' },
  { label: 'Diabetes', value: 'st_diabetes' },
  { label: 'Fumante', value: 'fumante' },
  { label: 'Gestante', value: 'gestante' },
  { label: 'Hanseníase', value: 'hanseníase' },
  { label: 'Hipertensão', value: 'st_hipertensao_arterial' },
  { label: 'Hipertensos e diabéticos', value: 'hiperdia' },
  { label: 'Infarto', value: 'infarto' },
  { label: 'Internação recente', value: 'internacaoRecente' },
  { label: 'Morador de rua', value: 'moradorDeRua' },
  { label: 'Usa álcool', value: 'usaAlcool' },
  { label: 'Usa drogas', value: 'usaDrogras' },
  { label: 'Problema saúde mental', value: 'tratamentoPsiquiátrico' },
  { label: 'Tuberculose', value: 'Tuberculose' },
  { label: 'Sem comorbirdade', value: 'semComorbirdades' },
  { label: 'Com alguma comorbidade', value: 'comAlgumaComorbidade' },
  { label: 'Pessoa idosa', value: 'pessoaIdosa' },
  { label: 'Criança', value: 'criancas' },
  { label: 'Bolsa família', value: 'bolsaFamilia' },
  { label: 'Mulher', value: 'mulher' },
]
export const labelsDoenca = {
  Acamado: 'st_acamado',
  Câncer: 'st_cancer',
  Deficiência: [
    'st_deficiencia',
    'st_defi_auditiva',
    'st_defi_intelectual_cognitiva',
    'st_defi_outra',
    'st_defi_visual',
    'st_defi_fisica',
  ],
  AVC: 'st_avc',
  'Doenças cardíacas': [
    'st_doenca_cardiaca',
    'st_doenca_card_insuficiencia',
    'st_doenca_card_outro',
  ],
  'Doenças nos rins': [
    'st_problema_rins',
    'st_problema_rins_insuficiencia',
    'st_problema_rins_outro',
  ],
  'Doenças respiratórias': [
    'st_doenca_respiratoria',
    'st_doenca_respira_asma',
    'st_doenca_respira_dpoc_enfisem',
    'st_doenca_respira_outra',
  ],
  Domiciliado: 'st_domiciliado',
  Fumante: 'st_fumante',
  Gestante: 'st_gestante',
  Hanseníase: 'st_hanseniase',
  Hipertensão: 'st_hipertensao_arterial',
  Diabetes: 'st_diabete',
  Infarto: 'st_infarto',
  'Internação recente': 'st_internacao_12',
  'Morador de rua': 'st_morador_rua',
  'Usa álcool': 'st_alcool',
  'Usa drogas': 'st_outra_droga',
  'Problema saúde mental': 'st_tratamento_psiquiatra',
  Tuberculose: 'st_tuberculose',
  'Bolsa família': 'tem_pbf',
  Mulher: 'st_mulher',
  Criança: 'st_crianca',
  'Pessoa idosa': 'st_pessoa_idosa',
}

export function getComobidades(data) {
  return data.map((obj) => {
    const comorbidades = []
    Object.entries(labelsDoenca).forEach(([label, value]) => {
      if (Array.isArray(value)) {
        const values = value.filter((v) => obj[v] == 1)
        if (values.length > 0) {
          comorbidades.push({ label, values })
        }
      } else {
        if (obj[value] != undefined && obj[value] == 1) {
          comorbidades.push({ label, values: [value] })
        } else {
          let fci_atual =
            obj.fci_atual != null ? JSON.parse(obj.fci_atual) : null
          if (fci_atual != null && fci_atual[value] == 1) {
            comorbidades.push({ label, values: [value] })
          }
        }
      }
    })

    // Check if the comorbidades array has objects with the labels "Diabéticos" and "Hipertensão"
    let hasDiabeticos = false
    let hasHipertensao = false
    for (const comorbidade of comorbidades) {
      if (comorbidade.label === 'Diabetes') {
        hasDiabeticos = true
      }
      if (comorbidade.label === 'Hipertensão') {
        hasHipertensao = true
      }
    }

    // If both "Diabéticos" and "Hipertensão" are found, add a new object with the label "Hipertensos e diabéticos"
    if (hasDiabeticos && hasHipertensao) {
      comorbidades.push({ label: 'Hipertensão e diabetes', values: null })
    }

    // Idosos
    // if (obj.idade >= 60) {
    //   comorbidades.push({ label: 'Pessoa idosa', values: null })
    // }

    // Crianças
    // if (obj.idade < 6) {
    //   comorbidades.push({ label: 'Criança', values: null })
    // }

    // If comorbidades is empty, add an object with the label "Sem comorbidades"
    if (comorbidades.length === 0) {
      comorbidades.push({ label: 'Sem comorbidades', values: null })
    }

    return { ...obj, comorbidades }
  })
}
export function filtrarComorbidades(comorbidades) {
  const temComorbidadeHipertensosDiabeticos = comorbidades.some(
    (comorbidade) => {
      return comorbidade.label === 'Hipertensão e diabetes'
    }
  )

  if (temComorbidadeHipertensosDiabeticos) {
    return comorbidades.filter((comorbidade) => {
      return (
        comorbidade.label !== 'Hipertensão' && comorbidade.label !== 'Diabetes'
      )
    })
  }

  return comorbidades
}

export function filtroDoenca(items, label) {
  const comorbidadeSelecionada = label

  if (comorbidadeSelecionada === 'Todas') {
    return items
  } else if (comorbidadeSelecionada === 'Sem comorbirdade') {
    return items.filter((item) => {
      return (
        item.comorbidades.length === 1 &&
        item.comorbidades[0].label === 'Sem comorbidades'
      )
    })
  } else if (comorbidadeSelecionada === 'Com alguma comorbidade') {
    return items.filter((item) => {
      return (
        item.comorbidades.length > 0 &&
        item.comorbidades[0].label !== 'Sem comorbidades'
      )
    })
  } else if (comorbidadeSelecionada === 'Hipertensos e diabéticos') {
    return items.filter((item) => {
      return item.comorbidades.some((comorbidade) => {
        return comorbidade.label === 'Hipertensão e diabetes'
      })
    })
  } else {
    return items.filter((item) => {
      return item.comorbidades.some(
        (comorbidade) => comorbidade.label === comorbidadeSelecionada
      )
    })
  }
}
